import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import ContentPackCoursePreviewModal from '../../../content-packs/ContentPackCoursePreviewModal';
import { CalendarSimulationPreviewModal } from './CalendarSimulationPreview';
import SimulationCollectionPreview from '../../../sim-collections/SimulationCollectionPreview';
import { useModalStack } from '../../../../components/Modal/ModalStackContext';
import { ModalProvider } from '../../../../components/Modal/ModalContext';


// Calendar-specific course preview wrapper
export const CalendarCoursePreview = ({ courseId, onClose, style, open = true, ...props }) => {
    return (
        <ModalProvider>
            <ContentPackCoursePreviewModal
                {...props}
                courseId={courseId}
                context="calendar"
                onClose={onClose}
                open={open} // FIXED: Use the open prop from modal stack
                style={style} // Pass through z-index from modal stack
                />
        </ModalProvider>
    );
};

// Calendar-specific simulation preview wrapper
export const CalendarSimulationPreview = ({ simulationId, onClose, style, open = true, ...props }) => {
    return (
        <CalendarSimulationPreviewModal
            {...props}
            simulationId={simulationId}
            onClose={onClose}
            open={open} // FIXED: Use the open prop from modal stack
            showBackdrop={false}
            isStandalone={true}
            style={style} // Pass through z-index from modal stack
        />
    );
};

// FIXED: Calendar-specific collection preview wrapper - now includes Dialog wrapper
export const CalendarCollectionPreview = ({ collectionId, onClose, style, open = true, ...props }) => {
    const { pushModal } = useModalStack();

    const handleNestedSimulationPreview = (simulationId) => {
        pushModal({
            type: 'simulationPreview',
            props: { simulationId }
        });
    };

    // Get z-index from modal stack or use default
    const zIndexValue = style?.zIndex || 1300;

    return (
        <Dialog
            open={open} // FIXED: Use the open prop from modal stack instead of hardcoded true
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            // Apply z-index at Dialog level to ensure proper layering
            style={{ zIndex: zIndexValue }}
            PaperProps={{
                sx: {
                    width: '70%',
                    height: '80%',
                    margin: '0 auto',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                }
            }}
        >
            <DialogContent sx={{ p: 0, height: '100%' }}>
                <ModalProvider>
                <SimulationCollectionPreview
                    {...props}
                    collectionId={collectionId}
                    onNestedSimulationPreview={handleNestedSimulationPreview}
                    context="calendar"
                    />
                </ModalProvider>
            </DialogContent>
        </Dialog>
    );
};